function copyShareLinkToClipBoard() {
    const shareWrapper = $('.js-share-link-wrapper');
    shareWrapper.each(function () {
        const wrapper = $(this);
        const input = $(this).find('.js-share-link-field');
        const btn = $(this).find('button:not(.js-btn-field-clear)');

        btn.on('click', function () {
            input.select();
            document.execCommand('copy');

            wrapper.find('.js-share-link-sign') != undefined &&
                wrapper.find('.js-share-link-sign').addClass('active');
        });
    });
}

runIfElementExist(copyShareLinkToClipBoard, '.js-share-link-field');

$(document).on('click', '.js-copy-link-btn', function () {
    const link = $(this).data('link');
    navigator.clipboard.writeText(link);
});
